import { useParams } from 'react-router-dom';
import { useState } from 'react';

import './FileReady.css';
import DownloadModal from '../DownloadModal/DownloadModal';

import woman1 from '../assets/images/woman1.jpg';
import woman2 from '../assets/images/woman2.jpg';
import woman3 from '../assets/images/woman3.jpg';
import woman4 from '../assets/images/woman4.jpg';

export default function FileReady() {
    const { id } = useParams();
    const [openModal, setOpenModal] = useState(false);

    return (
        <section className="file-ready">

            <img className="file-ready__image file-ready__image_one" src={woman1} />
            <img className="file-ready__image file-ready__image_two" src={woman2} />
            <img className="file-ready__image file-ready__image_three" src={woman3} />
            <img className="file-ready__image file-ready__image_four" src={woman4} />

            <div className="file-ready__card">

                <div className="file-ready__icon">
                    ✓
                </div>

                <h1 className="file-ready__title">
                    Ваш файл готов
                </h1>

                <p className="file-ready__subtitle">
                    Сжатие завершено успешно
                </p>

                <div className="file-ready__file">
                    <span>
                        compressed-video-{id}.mp4
                    </span>
                </div>

                <a href="#" className="file-ready__button" onClick={() => setOpenModal(true)}>
                    Скачать
                </a>

            </div>

            {openModal && (
                <DownloadModal onClose={() => setOpenModal(false)} id={id} />
            )}

        </section>

    );
}